import React from 'react';

interface GreenPillProps {
  icon?: React.ReactNode;
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
}

export default function GreenPill({ icon, children, onClick, className = '' }: GreenPillProps) {
  const baseClasses =
    'backdrop-blur-[3px] bg-[#233b22] border border-[rgba(141,210,144,0.4)] rounded-[48px] px-2.5 sm:px-3 py-1 sm:py-1.5 flex items-center gap-1.5';

  const Component = onClick ? 'button' : 'div';
  const interactiveProps = onClick
    ? {
        onClick,
        className: `${baseClasses} ${className} cursor-pointer hover:bg-[#2a4529] transition-colors duration-200`,
        type: 'button' as const,
      }
    : {
        className: `${baseClasses} ${className}`,
      };

  return (
    <Component {...interactiveProps}>
      {icon && <div className="flex-shrink-0">{icon}</div>}
      <span
        className="text-[#8dd290] text-[11px] sm:text-[12px] font-normal leading-[1.1]"
        style={{ fontFamily: 'Inter Display' }}
      >
        {children}
      </span>
    </Component>
  );
}
